/**
 * Sticky mobile add-to-cart bar. Shows once the real add-to-cart button
 * scrolls out of view, and mirrors its state (label/disabled/price) rather
 * than duplicating the cart form.
 */
(function () {
  function init(bar) {
    const targetButtonId = bar.dataset.targetButton;
    const targetPriceId = bar.dataset.targetPrice;
    const targetButton = document.getElementById(targetButtonId);
    const targetPriceContainer = document.getElementById(targetPriceId);
    const stickyButton = bar.querySelector('[data-sticky-add-to-cart]');
    const stickyLabel = bar.querySelector('[data-sticky-button-label]');
    const stickyPrice = bar.querySelector('[data-sticky-price]');

    if (!targetButton || !stickyButton) return;

    stickyButton.addEventListener('click', () => {
      if (targetButton.disabled) return;
      targetButton.click();
    });

    function syncButtonState() {
      stickyButton.disabled = targetButton.disabled;
      if (stickyLabel) stickyLabel.textContent = targetButton.textContent.trim();
    }

    function syncPrice() {
      if (!targetPriceContainer || !stickyPrice) return;
      const priceEl = targetPriceContainer.querySelector(
        '.price-item--sale:not(.hidden), .price-item--regular:not(.hidden)'
      );
      if (priceEl) stickyPrice.textContent = priceEl.textContent.trim();
    }

    syncButtonState();
    syncPrice();

    if ('MutationObserver' in window) {
      new MutationObserver(syncButtonState).observe(targetButton, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
      });
      if (targetPriceContainer) {
        new MutationObserver(syncPrice).observe(targetPriceContainer, { childList: true, subtree: true });
      }
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -10% 0px' }
      );
      observer.observe(targetButton);
    } else {
      bar.classList.add('is-visible');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sticky-atc]').forEach(init);
  });
})();
